import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const Settings = ({ className }) => {
    const password = useSelector(state => state.auth.password);
    const username = useSelector(state => state.auth.username);

    return (
        <div className={className}>
            <div className="Settings__Item">
                <h3>اطلاعات اپلیکیشن</h3>
                <ul>
                    <li>
                        <h4>نسخه</h4>
                        <span>۱</span>
                    </li>
                    <li>
                        <h4>راه تماس</h4>
                        <span>Site@Hamyarsystem.com</span>
                    </li>
                </ul>
            </div>
            <div className="Settings__Item">
                <h3>اطلاعات کاربر</h3>
                <ul>
                    <li>
                        <h4>نام کاربری</h4>
                        <span>{username}</span>
                    </li>
                    <li>
                        <h4>رمز عبور</h4>
                        <span>{password}</span>
                    </li>
                </ul>
            </div>
        </div>
    );
};

Settings.propTypes = {
    className: PropTypes.string.isRequired
};

export default styled(Settings)`
    height: calc(100vh - 160px);
    padding: 15px 30px;
    overflow: auto;
    overflow-x: hidden;
    padding-top: 50px;

    .Settings__Item {
        margin-bottom: 20px;

        > h3 {
            font-size: 12px;
            line-height: 21px;
            font-weight: bold;
            color: #0d1fa1;
            margin-bottom: 10px;
        }

        ul {
            background: #fff;
            border-radius: 3px;
            box-shadow: 0 3px 10px #e8ebff;
            padding: 5px 25px;

            > li {
                display: flex;
                flex-flow: row wrap;
                align-items: center;
                justify-content: space-between;
                padding: 12px 0px;
                border-bottom: 1px solid #dadef9;

                &:last-child {
                    border: none;
                }

                h4,
                span {
                    font-size: 12px;
                    line-height: 21px;
                    font-weight: 300;
                    color: #0d1fa1;
                }

                span {
                    direction: ltr;
                }
            }
        }
    }
`;
